import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {Subject} from 'rxjs';
import {AventiObject} from 'src/app/models/AventiObject';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from 'src/environments/environment';
import {Key, KEY_VALUE} from 'src/app/components/field-scan/types';
import {ListboxClickEvent} from 'primeng/listbox';
import {Router} from '@angular/router';

type GroupedObjects = {
  label: string,
  value: string,
  items: AventiObject[]
}

@Component({
  selector: 'app-object-name-search',
  templateUrl: './object-name-search.component.html',
  styleUrls: ['./object-name-search.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ObjectNameSearchComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {
  @Input() objectsName: AventiObject[];
  @Input() objectsTfm: AventiObject[];
  @Input() objectsRds: AventiObject[];
  @Input() projectName: string;
  @Input() projectId: string;
  @Input() key: Key;
  objects: AventiObject[];
  objectsGroupedByType: GroupedObjects[];
  selectedObject: AventiObject;
  mobileQuery: MediaQueryList;
  nameHint = 'Du kan søke på en substreng feks. på slutten av navnet';
  tfmHint = 'Du kan søke på en substreng feks. på slutten av TFM Tag-en';
  rdsHint = 'Du kan søke på en substreng feks. på slutten av RDS Tag-en';
  hint: string;
  listStyle = {
    'max-height': 'calc(100vh - 360px)',
    'overflow-x': 'auto',
    'white-space': 'nowrap',
  };
  recreateListbox = true;
  private ngUnsubscribe = new Subject();
  private needsScrollReset = false;

  constructor(
    media: MediaMatcher,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setObjects(changes);
  }

  ngAfterViewChecked() {
    if (this.needsScrollReset) {
      this.needsScrollReset = false;
      // this.scrollToTop();

      this.recreateListbox = false;
      // turn it back on next tick
      setTimeout(() => this.recreateListbox = true, 0);
    }
  }

  ngOnInit(): void {
  }

  async itemSelected($event: ListboxClickEvent) {
    const object: AventiObject = $event.option;
    if (!object || !object.id) {
      console.warn('No object selected or object has no id');
      return;
    }
    await this.router.navigate([`/fs/${this.projectId}/o/${object.id}`]);
  }

  groupObjects(scrollToTop: boolean) {
    // group objects by type.id
    const grouped = {};
    this.objects.forEach((obj) => {
      const typeId = obj.type.id;
      if (!grouped[typeId]) {
        grouped[typeId] = [];
      }
      grouped[typeId].push(obj);
    });
    // convert grouped object to array of GroupedObjects
    const newObjectsGroupedByType = Object.keys(grouped).map((key) => {
      return {
        label: grouped[key][0].type.name,
        value: key,
        items: grouped[key]
      };
    });
    if (scrollToTop) {
      this.updateData(newObjectsGroupedByType);
    } else {
      this.objectsGroupedByType = newObjectsGroupedByType;
    }
  }

  updateData(newGroups: GroupedObjects[]) {
    this.objectsGroupedByType = [...newGroups];
    // tell Angular something changed
    this.cdr.markForCheck();
    // schedule a scroll reset in the next view-check pass
    this.needsScrollReset = true;
  }

  private setObjects(changes: SimpleChanges) {
    if (changes.objectsName && changes.objectsName.currentValue) {
      this.objectsName = changes.objectsName.currentValue;
      if (this.key?.value === KEY_VALUE.NAME) {
        this.objects = this.objectsName;
      }
    }
    if (changes.objectsTfm && changes.objectsTfm.currentValue) {
      this.objectsTfm = changes.objectsTfm.currentValue;
      if (this.key?.value === KEY_VALUE.TFM_TAG) {
        this.objects = this.objectsTfm;
      }
    }
    if (changes.objectsRds && changes.objectsRds.currentValue) {
      this.objectsRds = changes.objectsRds.currentValue;
      if (this.key?.value === KEY_VALUE.RDS_TAG) {
        this.objects = this.objectsRds;
      }
    }
    if (changes.key) {
      this.key = changes.key.currentValue || 'tfmTag'; // Default to 'tfmTag' if not provided
      switch (this.key.value) {
      case KEY_VALUE.NAME:
        this.hint = this.nameHint;
        this.objects = this.objectsName;
        break;
      case KEY_VALUE.TFM_TAG:
        this.hint = this.tfmHint;
        this.objects = this.objectsTfm;
        break;
      case KEY_VALUE.RDS_TAG:
        this.hint = this.rdsHint;
        this.objects = this.objectsRds;
        break;
      default:
        console.warn(`Unknown key: ${this.key}`);
      }
    }
    if (this.objects) {
      this.groupObjects(changes.key !== undefined);
    }
  }

}
